import React from "react";
// import { translate } from "react-i18next";
import { NPSLabel } from "../Score/NPS/styles";
import { SatisfactionLabel } from "../Score/Satisfaction/styles";
import { YesNoLabel } from "../Score/YesNo/styles";
import { colors } from "../../../styles";
import {
  VeryUnsatisfied,
  Unsatisfied,
  Neutral,
  Satisfied,
  VerySatisfied
} from "../../../assets/images";

export const types = {
  satisfaction: [
    {
      response: 1,
      Label: SatisfactionLabel,
      color: colors.positive,
      description: "imSatisfied"
    },
    {
      response: 2,
      Label: SatisfactionLabel,
      color: colors.negative,
      description: "imDissatisfied"
    }
  ],
  smiles: [
    {
      response: 1,
      Label: <img src={VeryUnsatisfied} alt="Very unsatisfied" />
    },
    {
      response: 2,
      Label: <img src={Unsatisfied} alt="Unsatisfied" />
    },
    {
      response: 3,
      Label: <img src={Neutral} alt="Neutral" />
    },
    {
      response: 4,
      Label: <img src={Satisfied} alt="Satisfied" />
    },
    {
      response: 5,
      Label: <img src={VerySatisfied} alt="Very satisfied" />
    }
  ],
  NPS: [
    {
      response: 0,
      Label: NPSLabel,
      color: colors.npsZero,
      description: 0
    },
    {
      response: 1,
      Label: NPSLabel,
      color: colors.npsOne,
      description: 1
    },
    {
      response: 2,
      Label: NPSLabel,
      color: colors.npsTwo,
      description: 2
    },
    {
      response: 3,
      Label: NPSLabel,
      color: colors.npsThree,
      description: 3
    },
    {
      response: 4,
      Label: NPSLabel,
      color: colors.npsFour,
      description: 4
    },
    {
      response: 5,
      Label: NPSLabel,
      color: colors.npsFive,
      description: 5
    },
    {
      response: 6,
      Label: NPSLabel,
      color: colors.npsSix,
      description: 6
    },
    {
      response: 7,
      Label: NPSLabel,
      color: colors.npsSeven,
      description: 7
    },
    {
      response: 8,
      Label: NPSLabel,
      color: colors.npsEight,
      description: 8
    },
    {
      response: 9,
      Label: NPSLabel,
      color: colors.npsNine,
      description: 9
    },
    {
      response: 10,
      Label: NPSLabel,
      color: colors.npsTen,
      description: 10
    }
  ],
  yesNo: [
    {
      response: 1,
      Label: YesNoLabel,
      color: colors.positive,
      description: "yes"
    },
    {
      response: 2,
      Label: YesNoLabel,
      color: colors.negative,
      description: "no"
    }
  ]
};
